import React, { Component } from 'react';
import { Button, ButtonGroup, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import Api from './Api';

class VisitTime extends Component {

  render() {
    if (!this.props.string) return <span>Never</span>;

    const date = new Date(this.props.string);
    const seconds = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
    const text = (date.getMonth() + 1)+'/'+date.getDate()+' '+date.getHours()+':'+seconds;

    return <span>{text}</span>;
  }
}

class TeamInvitationGuest extends Component {

  getPreferredContact(guest) {
    if (guest.contact_method === 'phone_number') {
      return guest.phone_number;
    }
    return guest.email;
  }

  _loginAsGuest = e => {
    e.preventDefault();
    Api.teamLoginAsGuest(this.props.guest.guest_id);
  }

  render() {
    const guest = this.props.guest;
    return (
      <tr className="row m-0" key={'row'+guest.guest_id}>
        <td className="move-btn-group hidden-lg-down col-xl-1">
          {this.props.canMoveUp ? (
          <Button size="sm" onClick={() => this.props.onMove(-1)}>Up</Button>
          ) : null}
          {this.props.canMoveDown ? (
          <Button size="sm" onClick={() => this.props.onMove(1)}>Down</Button>
          ) : null}
        </td>
        <td className="align-middle col-8 col-sm-5 col-md-4 col-lg-3">
          {guest.first_name} {guest.last_name}
          (<a href="#" onClick={this._loginAsGuest}>login as</a>)
        </td>
        <td className={'col-4 col-sm-2 col-xl-1 rsvp rsvp-'+guest.rsvp}>
          {guest.rsvp ? guest.rsvp.charAt(0).toUpperCase()+guest.rsvp.substr(1) : 'Invited'}
        </td>
        <td className="hidden-md-down col-lg-3">{guest.email}</td>
        <td className="hidden-md-down col-lg-2">{guest.phone_number}</td>
        <td className="hidden-xs-down col-sm-5 col-md-4 hidden-lg-up">{this.getPreferredContact(guest)}</td>
        <td className="hidden-sm-down col-md-2"><VisitTime string={guest.last_visit_time}/></td>
      </tr>
    );
  }
}

class TeamInvitationHeader extends Component {

  render() {
    const invitation = this.props.invitation;
    return (
      <div className="d-flex align-items-center justify-content-between">
        <h4>
          {invitation.name}
          <Button
            onClick={() => this.props.onRename(invitation)}
            size="sm"
            className="ml-3"
            style={{
              fontSize:'.7em',
              marginBottom:'.1em',
            }}>Rename</Button>
        </h4>
        <ButtonGroup>
          {this.props.canMoveUp ? (
          <Button size="sm" onClick={e => this.props.onMove(-1)}>Up</Button>
          ) : null}
          {this.props.canMoveDown ? (
          <Button size="sm" onClick={e => this.props.onMove(1)}>Down</Button>
          ) : null}
        </ButtonGroup>
      </div>
    );
  }
}

class TeamInvitation extends Component {

  render() {
    const invitation = this.props.invitation;
    return (
      <div className="invitation">
        <TeamInvitationHeader
          invitation={invitation}
          canMoveUp={this.props.canMoveUp}
          canMoveDown={this.props.canMoveDown}
          onMove={this.props.onMove}
          onRename={this.props.onRename}
        />
        <Row>
          <Table hover bordered>
            <tbody>
              {invitation.guests.map((guest, idx) => (
              <TeamInvitationGuest
                guest={guest}
                canMoveUp={idx > 0}
                canMoveDown={idx < invitation.guests.length - 1}
                onMove={this.props.onMoveGuest.bind(null, idx)}
                key={`guest${guest.guest_id}`}
              />
              ))}
            </tbody>
          </Table>
        </Row>
      </div>
    );
  }
}

class TeamInvitationRenameModal extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      nameInput: '',
    }
  }

  componentWillMount() {
    this._updateNameInput(this.props);
  }

  componentWillReceiveProps(newProps) {
    this._updateNameInput(newProps);
  }

  _updateNameInput(props) {
    this.setState({
      nameInput: props.invitation ? props.invitation.name : '',
    })
  }

  _saveInvitationName = () => {
    this.props.invitation.name = this.state.nameInput;
    this.props.onSaveName(this.props.invitation);
  }

  _onSubmitForm = e => {
    e.preventDefault();
    this._saveInvitationName();
  }

  render() {
    if (!this.props.invitation) {
      return null;
    }

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.onClose}>
        <ModalHeader>Rename Invitation</ModalHeader>
        <ModalBody>
          <Form onSubmit={this._onSubmitForm}>
            <FormGroup>
              <Label hidden for="invitation_name_input">New name</Label>
              <Input
                ref="invitation_name"
                type="text"
                autoFocus
                id="invitation_name_input"
                placeholder="Invitation name"
                onChange={e => this.setState({nameInput: e.target.value })}
                value={this.state.nameInput}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this._saveInvitationName}>Save</Button>
          {' '}
          <Button color="secondary" onClick={this.props.onClose}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

class TeamInvitationsTable extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  _renameInvitation = invitation => {
    this.setState({
      renameModal: true,
      renameInvitation: invitation,
    });
  }

  _saveInvitationName = invitation => {
    Api.teamSetInvitationName(invitation.invitation_id, invitation.name);
    this._closeRenameModal();
    this.forceUpdate();
  }

  _closeRenameModal = () => {
    this.setState({ renameModal: false });
  }

  render() {
    if (!this.props.invitations) { return <div/>; }
    return (
      <div className="invitations">
        {this.props.invitations.map((invitation, invitationIdx) => (
        <TeamInvitation
          invitation={invitation}
          canMoveUp={invitationIdx > 0}
          canMoveDown={invitationIdx < this.props.invitations.length - 1}
          onMove={this.props.onMoveInvitation.bind(null, invitationIdx)}
          onMoveGuest={this.props.onMoveGuest.bind(null, invitationIdx)}
          onRename={this._renameInvitation}
          key={`invitation${invitation.invitation_id}`}
        />
        ))}
        <TeamInvitationRenameModal
          invitation={this.state.renameInvitation}
          isOpen={this.state.renameModal}
          onSaveName={this._saveInvitationName}
          onClose={this._closeRenameModal}
        />
      </div>
    )
  }
}

export default TeamInvitationsTable;



// WEBPACK FOOTER //
// ./src/TeamInvitationsTable.js